import { ActionTree } from 'vuex';
import { RootState } from '@/ui/store/types/root-module.types';
import serviceProvider from '@/services/service-provider';
import { iReview } from '@/entities/review/review.types';
import { GameState } from '../../types/game-module.types';
import { GAME_MUTATIONS } from './mutations';

export const actions: ActionTree<GameState, RootState> = {
  async findGameById({ commit }, id: number) {
    try {
      const game = await serviceProvider.game.findById(id);
      commit(GAME_MUTATIONS.SET_ACTIVE_GAME, game);
    } catch (error) {
      commit(GAME_MUTATIONS.SET_ACTIVE_GAME, undefined);
    }
  },
  setGames({ commit }, games) {
    commit(GAME_MUTATIONS.SET_SEARCH_GAMES, games);
  },
  async findReviewsByGameId({ commit, dispatch }, id: number) {
    try {
      const reviews = await serviceProvider.review.getReviewsByGameId(id);

      commit(GAME_MUTATIONS.SET_ACTIVE_GAME_REVIEWS, reviews);
      dispatch('calculateRating', reviews);
    } catch (error) {
      commit(GAME_MUTATIONS.SET_ACTIVE_GAME_REVIEWS, []);
    }
  },
  calculateRating({ commit }, reviews: iReview[]) {
    if (!reviews.length) {
      commit(GAME_MUTATIONS.SET_ACTIVE_GAME_RATING, 0);
      return;
    }

    const ratingSum = reviews.reduce((sum, review) => sum + review.rating, 0);

    const rating = ratingSum / reviews.length;

    commit(GAME_MUTATIONS.SET_ACTIVE_GAME_RATING, rating);
  },
};
